import { styled, TableCell, TableContainer, Table, TableHead } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export const StyledTableCell = styled(TableCell)({
  borderBottom: "none",
  padding: "0px",
  textAlign: "center",
});

export const StyledTableContainer = styled(TableContainer)({
  boxShadow: "none",
  margin: "0 auto",
  border: "none",
  width: "100%",
});

export const StyledTable = styled(Table)({
  border: "none",
});

export const StyledTableHead = styled(TableHead)({
  top: 0,
  backgroundColor: HNSColors.neutrals[900],
  zIndex: 1,
});
